module.exports = __webpack_public_path__ + "static/media/bg_login2.0c7f0857.jpg";